import React from 'react'
import Advantages from '../../components/Advantages/Advantages'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'

const Page = (props: {element: React.ReactNode}) => {
  return (
    <div>
        <Header/>
        {props.element}
        <Advantages/>
        <Footer/>
    </div>
  )
}

export default Page